import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/tmp/build_5b96a0a9/layouts/default.vue").then(m => m.default || m)),
  "framed-prints": defineAsyncComponent(() => import("/tmp/build_5b96a0a9/layouts/framed-prints.vue").then(m => m.default || m)),
  noauth: defineAsyncComponent(() => import("/tmp/build_5b96a0a9/layouts/noauth.vue").then(m => m.default || m))
}